// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyByK0fMaBffD7Lx3K2QCdKJsxgb-eSUWV8",
  authDomain: "my-health-pace.firebaseapp.com",
  projectId: "my-health-pace",
  storageBucket: "my-health-pace.firebasestorage.app",
  messagingSenderId: "837273798976",
  appId: "1:837273798976:web:6345bc5623e862dd6bd2a5"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Set auth persistence to LOCAL (survives browser refresh and close)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase auth persistence enabled (localStorage)');
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });

export { auth, googleProvider };